import { render, staticRenderFns } from "./ShowScoreDescriptionModal.vue?vue&type=template&id=f37f1e56&scoped=true&"
import script from "./ShowScoreDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./ShowScoreDescriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37f1e56",
  null
  
)

export default component.exports